module.exports = __webpack_public_path__ + "images/jennie_f4d2ac5a989659395cf08f6adb32de76.jpg";